import { useEffect, useRef, useState } from 'react';

interface UseSwiperAni {
    length: number;
    sectionRef: React.RefObject<HTMLElement>;
}

const useSwiperAni = ({ length, sectionRef }: UseSwiperAni) => {
    const [angle, setAngle] = useState(0);
    const [index, setIndex] = useState(1);

    const topRef = useRef(0);

    const screenNum = length + 0.2;
    // 设置 section 高度
    useEffect(() => {
        if (!sectionRef.current) return;
        sectionRef.current.style.height = `${screenNum * 100}vh`;
    }, [screenNum, sectionRef]);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!sectionRef.current) return;

        const screen = AniContainer.create({
            triggerElement: sectionRef.current, // 触发元素
            triggerHook: 0,
            offset: '0%',
            duration: window.innerHeight * length,
            onProcess: (process: number) => {
                // 进度条 0~1
                const totalProgress = process * length;
                const index = Math.min(length, Math.floor(totalProgress) + 1); // 当前屏索引 1~length
                setIndex(index);

                // 每屏角度 0~360
                const angle = Math.min(360, process * 360 + 360 / length);
                setAngle(angle);
            },
            onEnter: () => {
                if (!sectionRef.current) return;
                // 获取当前元素距离页面顶部的距离
                const distanceToTop = sectionRef.current.getBoundingClientRect().top + window.scrollY + 2;
                topRef.current = distanceToTop;
            },
        });
        return () => {
            screen.destroy?.();
        };
    }, [length, sectionRef]);

    // 点击切换滚动到第几屏幕
    const changeIndex = (index: number) => {
        if (typeof window === 'undefined') return;
        window.scrollTo({
            top: topRef.current + window.innerHeight * index,
            behavior: 'smooth',
        });
    };

    return {
        angle,
        index,
        changeIndex,
    };
};

export default useSwiperAni;
